import { FunctionComponent, useCallback, useMemo } from 'react'

import styled, { css } from 'styled-components'

import config from '@config'
import translate from '@i18n'
import useTracking, { TrackingFnType } from '@hooks/useTracking'
import AnswerFeedback from '@components/Chatbot/messages/AnswerFeedback'

const StyledAnswerFeedback = styled(AnswerFeedback)`
  ${({
    theme: {
      colors: { fillWeak },
    },
  }) => css`
    background-color: ${fillWeak};
    border-top: none;
    padding: 0;
    margin: 0;
  `}
`

const {
  usersnap: { articleSummaryWidgetKey },
} = config

const NewArticleSummaryFeedback: FunctionComponent<{ text: string }> = ({
  text,
}) => {
  const trackingOnClick = useCallback<TrackingFnType<{ label: string }>>(
    ({ extraData: { label } }) => ({
      event: 'article_summary_click',
      button_label: label,
    }),
    [],
  )
  const handleTrackingOnClick = useTracking(trackingOnClick)
  const customUserData = useMemo(() => ({ text }), [text])

  return (
    <StyledAnswerFeedback
      usersnapKey={articleSummaryWidgetKey}
      onboardingInProcess={false}
      trackingFunction={(rating) => handleTrackingOnClick({ label: rating })}
      customUsersnapData={customUserData}
      customFeedbackText={translate('newArticleSummary.feedback')}
      feedbackButtonsPosition="end"
      breakWords
    />
  )
}

export default NewArticleSummaryFeedback
